import { getCurrencyApi } from '../../api/currency';
import { ThunkAppDispatch } from '../../store';
import { setCurrencyAction } from './action';

export const getCurrencyThunk = (currencyId: number | string) => (dispatch: ThunkAppDispatch) => {
  getCurrencyApi({ currency: currencyId }).then((res) => {
    dispatch(setCurrencyAction(res));
    return res;
  });
};
